export default __webpack_public_path__ + "static/media/safety_gas_01.362d4940.jpg";